class Match{

  constructor(
    id,
    date,
    duration,
    teamAId,
    teamBId,
    courtID,
    teamAGoal,
    teamBGoal,
    team_a_alias,
    team_b_alias,
    draw_winner_team_id) {

    this.id = id || -1
    this.duration = duration || 90
    this.date = date || null
    this.courtID = courtID || -1
    this.teamAId = teamAId || -1
    this.teamBId = teamBId || -1
    this.court = null
    this.teamA = null
    this.teamB = null
    this.teamAGoal = teamAGoal
    this.teamBGoal = teamBGoal
    this.team_a_alias = team_a_alias || ""
    this.team_b_alias = team_b_alias || ""
    this.draw_winner_team_id = draw_winner_team_id || null
  }


  static parse(responseData){
    if(!responseData){return new Match()}
    let d = responseData
    return new Match(d.id,
      d.date ? new Date(d.date) : null,
      d.duration,
      d.team_a,
      d.team_b,
      d.court_obj ? d.court_obj.id : null,
      d.team_a_gol,
      d.team_b_gol,
      d.team_a_alias,
      d.team_b_alias,
      d.draw_winner_team_id
    )
  }
}


export default Match



// WEBPACK FOOTER //
// ./src/models/match.js